import styled from 'styled-components';

export const SelectAdressContainer = styled.div`
	position: absolute;
	left: 50%;
	transform: translate(-50%);
	background-color: white;
	padding: 20px;
	border-radius: 5px;
	top: 0;
	box-shadow: -3px 5px 20px 2px rgba(0, 0, 0, 0.3);
	-webkit-box-shadow: -3px 5px 20px 2px rgba(0, 0, 0, 0.3);
	-moz-box-shadow: -3px 5px 20px 2px rgba(0, 0, 0, 0.3);
	z-index: 1000;
	top: 15px;
`;

export const SampleListFilterContainer = styled.div`
	.label {
		font-size: 14px;
		margin-top: 8px !important;
		margin-bottom: 0px !important;
	}
`;